export enum PrintContext {
  Application = 1,
  Contact = 2,
  Vehicle = 4
}
